<template>
  <Breadcrumbs
      title="Day End Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Day End Report', path: '/dayend-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <DayEndReport />
    </div>
  </div>
</template>

<script>
import DayEndReport from './dayreport_form.vue'
export default {
  name: 'indexList',
  components: {
    DayEndReport,
  },
}

</script>
